import { ChangeEvent, useEffect, useState } from 'react'
import { FormControl, FormHelperText, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { Color, BasicOption, SimpleEventHandler } from '../../types'

interface Props {
  className?: string
  style?: any
  color?: Color
  disabled?: boolean
  error?: boolean
  helperText?: string
  label?: string
  name?: string
  onChange: SimpleEventHandler<string>
  options: BasicOption[]
  value: string | null
  row?: boolean
  size?: 'small' | 'medium'
}

export default function InputRadioGroup(props: Props): JSX.Element {
  const {
    color = 'primary',
    disabled,
    error,
    helperText,
    label,
    name,
    onChange,
    options,
    row = false,
    size = 'small',
    ...restOfProps
  } = props
  const [value, setValue] = useState<any>(null)

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value)
    }
  }, [props.value])

  function handleOnChange(_: ChangeEvent<HTMLInputElement>, value: string): void {
    setValue(value)
    onChange({ target: { name, value } })
  }

  function renderOptions(): JSX.Element[] {
    return options.map((option) => (
      <FormControlLabel
        key={option.label}
        value={option.value}
        label={option.label}
        control={<Radio size={size} color={color} disabled={disabled} />}
      />
    ))
  }

  return (
    <FormControl component="fieldset" error={error} {...restOfProps}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup name={name} value={value} onChange={handleOnChange} row={row}>
        {renderOptions()}
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}
